import React, { createContext, useState, ReactNode } from 'react';

export interface HomeItem {
  id: string;
  title: string;
  type: string
}

interface HomeContent {
  id: string;
  title: string;
  image?: string;
  videoUrl?: string;
  link?: string;
}

interface AppData {
  id?: string; 
  type?: string;
  title?: string;
  storeTitle?: string;
  shortDescription?: string;
  description?: string;
  icon?: string;
  logo?: string;
  appBarLogo?: string;
  radioLogo?: string;
  homeItems?: HomeItem[];
  navItems?: HomeItem[];
  moreItems?: HomeItem[];
}

interface AppContextProps {
  appData: AppData;
  updateAppData: (newData: AppData) => void;
}

export const AppContext = createContext<AppContextProps | undefined>(undefined);

export const AppProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [appData, setAppData] = useState<AppData>(() => {
    // Recuperar do localStorage ao carregar
    const savedData = localStorage.getItem('appData');
    return savedData ? JSON.parse(savedData) : {};
  });

  const updateAppData = (data: Partial<AppData>) => {
    setAppData((prev) => {
      const newData = { ...prev, ...data };
      localStorage.setItem('appData', JSON.stringify(newData)); // Salva no localStorage
      return newData;
    });
  };

  return (
    <AppContext.Provider value={{ appData, updateAppData }}>
      {children}
    </AppContext.Provider>
  );
};